goog.provide("shadow.js.shim.module$$mui$material$CardContent$default");
shadow.js.shim.module$$mui$material$CardContent$default = shadow.js.shim.module$$mui$material$CardContent.default;
